import { render, staticRenderFns } from "./AiReportDialog.vue?vue&type=template&id=037b1f6a"
import script from "./AiReportDialog.vue?vue&type=script&lang=js"
export * from "./AiReportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports